import { inject, Service } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GoogleService } from "./google-service";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { EntityKey } from "../entity/entity";
import { EntityKeyUtils } from "../utils/entity-key-utils";

@Service()
export class ShippingChargeService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly googleService: GoogleService = inject(GoogleService);
  private urlBase: string = environment.serviceUrl + "shippingCharges/";

  isTaskOpen(entityKey: EntityKey): Observable<string> {
    const url: string = this.urlBase + "isTaskOpen/" + entityKey.entityId + "/" + entityKey.entityRevision;
    return this.http.get(url, { headers: this.getRequestHeaders(), responseType: "text" });
  }

  createTask(entityKey: EntityKey): Observable<string> {
    const converted = EntityKeyUtils.convertToFullEntityKey(entityKey);
    const body: string = JSON.stringify(converted);
    const url: string = this.urlBase + "createManualChargeTask";
    return this.http.post(url, body, { headers: this.getPostHeaders(), responseType: "text" });
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

}
